// @flow

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Types
import type { Asset } from 'fc-model-assets/types'

// Selectors
import { assets$ } from 'fc-assets'

export default function (seasonId: number): Function {
  return createSelector(
    [
      assets$,
    ],
    (assets: Object): Array<Asset> => {
      let assetsOfSelectedSeason = []

      if (seasonId) {
        assetsOfSelectedSeason = _filter(assets, {season: seasonId})
      }

      return assetsOfSelectedSeason
    }
  )
}
